module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2a"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('span', {
    staticClass: "underline"
  }, [_vm._v("Getting Started")])]), _vm._v(" "), _c('div', {
    staticClass: "keep"
  }, [_c('h3', {
    staticClass: "h3a"
  }, [_vm._v("Basic Supplies")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_c('span', {
    staticClass: "cl_1E72B9"
  }, [_c('strong', [_vm._v("FABRIC:")])]), _vm._v(" All of the fabrics used in these quilts are 100% cotton. We recommend that you always prewash your cotton fabric.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "cl_1E72B9"
  }, [_c('strong', [_vm._v("DESIGN WALL:")])]), _vm._v(" There are a variety of design wall options. No matter which you choose, this is a tool you need. Our design walls are made from 1″-thick insulation foam that is available in 4′ × 8′ sheets. Use as many sheets as necessary to cover your space. They are easy to cut. We attached them to our walls with sheetrock screws. Becky’s design wall is covered with white flannel; Linda’s, with batting.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "cl_1E72B9"
  }, [_c('strong', [_vm._v("APPLIQUÉ THREAD:")])]), _vm._v(" Use cotton thread with cotton fabric. There are many brands to choose from. Try different brands until you find the one that works best for you. For hand appliqué, we recommend Superior MasterPiece 50-weight 2-ply cotton (available only on bobbins), Aurifil 50-weight cotton, and DMC 50-weight machine embroidery thread.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "cl_1E72B9"
  }, [_c('strong', [_vm._v("MACHINE-QUILTING THREAD:")])]), _vm._v(" For our machine quilting, we usually use the threads listed above. We want the appliqué to be enhanced by the quilting, not to be overshadowed by it. We like the matte finish of cotton thread. We quilt our quilts heavily, so the lighter-weight threads work well. However, if you plan to quilt far apart or want more visible quilting stitches, you should use a heavier thread.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "cl_1E72B9"
  }, [_c('strong', [_vm._v("HAND-QUILTING THREAD:")])]), _vm._v(" We like Gütermann’s cotton hand-quilting thread. Perle cotton in size 16 or 12 is nice when you want bigger, more visible stitches.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "cl_1E72B9"
  }, [_c('strong', [_vm._v("PINS:")])]), _vm._v(" Use ½″ sequin pins to pin the appliqué pieces in place. Use larger flower-head quilting pins to hold the positioning overlay in place.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "cl_1E72B9"
  }, [_c('strong', [_vm._v("NEEDLES:")])]), _vm._v(" For hand appliqué, Linda uses a size 11 Hemming & Son milliners (or straw) needle. Becky uses a Clover size 12 Black Gold sharp. There are many good needles available on the market. Find the one that fits "), _c('em', [_vm._v("your")]), _vm._v(" hand.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "cl_1E72B9"
  }, [_c('strong', [_vm._v("SCISSORS:")])]), _vm._v(" Use embroidery-size scissors for both paper and fabric. Small, sharp scissors are better for precise cutting.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "cl_1E72B9"
  }, [_c('strong', [_vm._v("ROTARY CUTTER, MAT, AND ACRYLIC RULER:")])]), _vm._v(" When trimming blocks to size and cutting borders, rotarycutting tools will give you the best results.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "cl_1E72B9"
  }, [_c('strong', [_vm._v("PENCILS:")])]), _vm._v(" To draw around templates onto fabric, we use a General’s Charcoal white pencil or a mechanical chalk pencil that holds a 9mm refill. Both Sewline and Bohin make these pencils. We use either the white or the gray chalk, depending on the color and value of the fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "cl_1E72B9"
  }, [_c('strong', [_vm._v("PERMANENT MARKERS:")])]), _vm._v(" To make the positioning overlay, a black Sharpie Ultra Fine Point Permanent Marker works well on clear or frosted vinyl. The Faber-Castell Quilter’s Pen Set from C&T Publishing works well also, and these pens are erasable when you use them on vinyl.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "cl_1E72B9"
  }, [_c('strong', [_vm._v("CLEAR OR FROSTED VINYL:")])]), _vm._v(" Use a clear or frosted flexible, medium-weight upholstery vinyl or Quilter’s Vinyl to make the positioning overlay. Frosted vinyl is transparent when placed on fabric. If the vinyl you buy comes with tissue paper, keep the tissue paper for storage. If your quilt shop does not have vinyl, look for it online or in stores that carry upholstery fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "cl_1E72B9"
  }, [_c('strong', [_vm._v("CLEAR, SINGLE-SIDED, HEAVYWEIGHT SELF-LAMINATING SHEETS:")])]), _vm._v(" We use these sheets to make templates. You can find these sheets at "), _c('a', {
    attrs: {
      "href": "http://www.pieceocake.com",
      "target": "_blank"
    }
  }, [_vm._v("www.pieceocake.com")]), _vm._v(", at most office supply stores, at some warehouse markets, or online. Buy the single-sided sheets, not the pouches. If you can’t find laminating sheets, use clear Con-Tact paper—it will work in a pinch.")]), _vm._v(" "), _c('p', {
    staticClass: "imagec"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "html/images/f0008-01.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Appliqué supplies")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "cl_1E72B9"
  }, [_c('strong', [_vm._v("SANDPAPER BOARD:")])]), _vm._v(" When tracing around templates onto fabric, place the fabric on the sandpaper side of the board. Then place the template on the fabric. You’ll love the way the sandpaper holds the fabric in place when you trace. We recommend the Essential Sandboard from Piece O’ Cake Designs.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "cl_1E72B9"
  }, [_c('strong', [_vm._v("WOODEN TOOTHPICK:")])]), _vm._v(" Use a round wooden toothpick to help turn under the turn-under allowance at points and curves. Wood has a texture that grabs and holds the fabric.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "cl_1E72B9"
  }, [_c('strong', [_vm._v("FUSIBLE WEB:")])]), _vm._v(" If you prefer to fuse and machine stitch the appliqué, use a paper-backed fusible web and follow the manufacturer’s instructions. It’s a good idea to test the fusible web on the fabric you will be using.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "cl_1E72B9"
  }, [_c('strong', [_vm._v("EQ PRINTABLES:")])]), _vm._v(" These are sheets of fabric that are already prepared for printing on an inkjet printer and are perfect for computer-generated documentation labels. This fabric comes in a variety of sizes in addition to the standard 8½″ × 11″ sheet.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "cl_1E72B9"
  }, [_c('strong', [_vm._v("NONSTICK PRESSING SHEET:")])]), _vm._v(" If you are doing fusible appliqué, a nonstick pressing sheet will protect the iron and ironing board.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "cl_1E72B9"
  }, [_c('strong', [_vm._v("FULL-SPECTRUM WORK LIGHT:")])]), _vm._v(" These lamps give off a bright, natural light. A floor lamp is particularly nice, because you can position it over your shoulder. Appliqué is much easier when you can see what you are doing.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "cl_1E72B9"
  }, [_c('strong', [_vm._v("BATTING:")])]), _vm._v(" We prefer to use cotton batting. Several good batts are on the market. It is a good idea to do some research to find the batt that suits you best. Currently we are using Mountain Mist Blue Ribbon or Cream Rose, Quilter’s Dream, and Tuscany by Hobbs.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "cl_1E72B9"
  }, [_c('strong', [_vm._v("QUILTING GLOVES:")])]), _vm._v(" These gloves make it easier to hold on to the quilt during machine quilting. We use the Machingers brand.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "cl_1E72B9"
  }, [_c('strong', [_vm._v("SEWING MACHINE:")])]), _vm._v(" Successful machine piecing and quilting requires the best sewing machine and table that you can afford. For piecing, we use Bernina machines. For machine quilting, we each use the Sweet Sixteen by Handi Quilter.")]), _vm._v(" "), _c('div', {
    staticClass: "keep"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }), _vm._v("Fabric Preparation")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Prewash your fabric before using it. Why?")])]), _vm._v(" "), _c('p', {
    staticClass: "noindentbull"
  }, [_c('span', {
    staticClass: "org"
  }, [_vm._v("•")]), _vm._v("  Prewash to remove excess dye and other chemicals in the cloth.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentbull"
  }, [_c('span', {
    staticClass: "org"
  }, [_vm._v("•")]), _vm._v("  Most cotton fabrics will shrink when washed and dried. Different fabrics shrink at different rates; it is better if the fabric shrinks "), _c('em', [_vm._v("before")]), _vm._v(" you sew it into the quilt.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentbull"
  }, [_c('span', {
    staticClass: "org"
  }, [_vm._v("•")]), _vm._v("  The turn-under allowance on your appliqué pieces will fray less if you wash and dry your fabric. Frayed edges can be hard to work with in hand appliqué.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentbull"
  }, [_c('span', {
    staticClass: "org"
  }, [_vm._v("•")]), _vm._v("  Fabric off the bolt has a finish that makes it a little slick. Washing removes this finish. In both piecing and appliqué, we find it much easier to sew together fabrics that are not sliding against each other.")]), _vm._v(" "), _c('p', {
    staticClass: "noindentbull"
  }, [_c('span', {
    staticClass: "org"
  }, [_vm._v("•")]), _vm._v("  Prewashed fabric feels and smells better in your hand.")]), _vm._v(" "), _c('div', {
    staticClass: "keep"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("About Our Fabric Requirements")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Cotton fabric is usually 40″–42″ wide off the bolt. To be safe, we calculate all our fabric requirements based on a 40″ width.")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Use the fabric requirements for each quilt as a guide, but remember that the yardage amounts can vary depending on how you cut the fabric. Our measurements allow for some fabric shrinkage and minor errors in cutting.")]), _vm._v(" "), _c('div', {
    staticClass: "keep"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("Seam Allowances")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("All machine piecing is designed for ¼″ seam allowances.")])]), _vm._v(" "), _c('div', {
    staticClass: "keep"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("Borders")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("This book’s cutting instructions are mathematically correct. However, variations in the finished size of the quilt top can result from slight differences in seam allowances. You should "), _c('em', [_vm._v("always")]), _vm._v(" measure your quilt before adding borders. When measuring, be sure to measure through the middle of the quilt top, not at the outer edges, which can stretch. Adjust the size of your borders if necessary.")])]), _vm._v(" "), _c('div', {
    staticClass: "keep"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_vm._v("Hand Appliqué or Fusible Web?")]), _vm._v(" "), _c('div', {
    staticClass: "keep"
  }, [_c('h4', {
    staticClass: "h4a"
  }, [_vm._v("What’s the Difference between Hand, Fusible, and Machine Appliqué?")]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("All appliqué begins with a drawing. You can use almost any appliqué method with almost any appliqué pattern. It is important to choose the method that makes you happy and produces the look you want in your quilt.")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Hand appliqué")]), _vm._v(" is the most traditional form of appliqué. The edges of the appliqué pieces are sewn by hand, which produces a softer look and feel. The turn-under allowance adds a bit of height at the edge of the appliqué. The added height from the turn-under allowance adds a feeling of depth that is not found in fused appliqué.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Why do we prefer "), _c('em', [_vm._v("hand")]), _vm._v(" appliqué? The true answer is that we enjoy handwork. As a matter of fact, we more than enjoy it—we love it! With stitching in hand, we are calmer, happier, and more able to deal with the stresses around us. It’s better than therapy!")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Hand appliqué is portable. You can stitch almost anywhere—waiting at the doctor’s office, during breaks at work, riding (not driving!) in the car, or watching TV. It is surprising how much stitching you can do in the odd moments of your day.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In "), _c('em', [_vm._v("fusible appliqué")]), _vm._v(", fabrics are "), _c('em', [_vm._v("glued")]), _vm._v(" together, most often with an iron-on fusible web. Fusible appliqué is faster than hand appliqué. It is also very flat, with clearly defined edges. Fused quilts can be stiff. Sometimes only the outer edges of the appliqué pieces are fused, in which case the center of the appliqué is softer.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There is some debate about the effect that fusible webs and fabric glues have on fabric. Only time will tell the long-term effect of these products.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', [_vm._v("Machine appliqué")]), _vm._v(" very often involves fusing the appliqué pieces to the background fabric and then finishing the edges on the sewing machine. If you leave the edges raw, they can sometimes fray. Many quilters machine stitch around those raw edges. Others use a turn-under allowance (sometimes secured with glue) and then finish the edge of the appliqué with machine stitching.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Machine appliqué, done well, takes time and skill.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Hand appliqué is the primary focus of this book. Where appropriate, we have included instructions for fusible web. If you choose to use fusible web in your quilt, please test the fabrics you plan to use and follow the manufacturer’s instructions carefully.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a065d5c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/html/9781607054726_05_ch1.vue
// module id = 69
// module chunks = 0